import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { authService } from '../api/authService/authService';
import { projectsApiService } from '../api/projects/projectsApiService';
import appReducer from '../modules/app/AppSlice';
import authorizationReducer from '../modules/authorization/AuthorizationSlice';
import tablesSlice from '../modules/tables/TablesSlice';

const rootReducer = combineReducers({
  appReducer,
  authorizationReducer,
  tablesSlice,
  [authService.reducerPath]: authService.reducer,
  [projectsApiService.reducerPath]: projectsApiService.reducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(authService.middleware, projectsApiService.middleware),
    devTools: true,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
